import { IAgreementListState } from '../interfaces/IAgreementListState';

export const initialAgreementListState: IAgreementListState = {
  data: [],
  findData: [],
  order: null,
  page: 0,
  pageCount: 0,
  totalCount: 0,
  searchValue: '',
  rejected: 0,
};
